<template>
  <v-card class="ma-10" flat tile>
    <v-row>
      <month-picker v-model="month" label="Select Month"></month-picker>
      <v-spacer />

      <div class="d-flex ">
        <v-btn
          @click="printReport"
          class="elevation-0"
          color="primary"
          outlined
          elevation="2"
        >
          <v-icon left> mdi-printer</v-icon>
          Print</v-btn
        >
      </div>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="profileViews"
      :items-per-page="10"
      :loading="loading"
    ></v-data-table>
  </v-card>
</template>

<script>
import { axios, Strings } from '../../../utils'
import MonthPicker from '../../../components/MonthPicker'
export default {
  components: {
    MonthPicker
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'PROFILE',
          align: 'start',
          sortable: true,
          value: 'business_name'
        },
        { text: 'HITS', align: 'start', sortable: true, value: 'total_views' }
      ],
      profileViews: [],
      month: ''
    }
  },
  mounted() {
    this.getProfileViews()
  },
  methods: {
    getProfileViews() {
      this.loading = true
      axios
        .get(
          `api/get-listing-views?month=${
            this.month ? this.month : new Date().toISOString().substr(0, 7)
          }`
        )
        .then(res => {
          this.profileViews = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    printReport() {
      window.open(
        `${Strings.baseUrl}/print-report?month=${
          this.month ? this.month : new Date().toISOString().substr(0, 7)
        }&type=profile&name=PROFILE HITS REPORT`,
        '_blank'
      )
    }
  },
  watch: {
    month: function() {
      this.getProfileViews()
    }
  }
}
</script>

<style lang="scss" scoped></style>
